import {h, Fragment} from "preact"
import { useState, useEffect } from 'preact/hooks'
import Filter from "./Filter"
import {createPlural} from "../helpers"

function updateOrderedArray(array, order) {
    return array.sort((a, b) => order.indexOf(a.value.toUpperCase()) - order.indexOf(b.value.toUpperCase()))
}

export default ({ facet }) => {


    const [active, setActive] = useState(false)
    const [facetThreshold, setFacetThreshold] = useState(1000);

    const handleClickMore = () => {
        setFacetThreshold((prev) => prev + (facet.data?.length - facetThreshold));
    }

    const isSize = facet.name.toLowerCase() === "size"

    if (isSize) {
        let sortIt = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "ONE", "00", "0", "2", "4", "6", "8", "10", "12", "14", "16", "30", "35", "36", "37", "38", "39", "40", "41"];
        updateOrderedArray(facet.data, sortIt);
    }

    return (
        <li class={`ns-sidebar-dropdown ${active ? 'ns-active' : ''}`}>
            <a
                class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-py-4 ns-accordion-panel ns-d-flex ns-justify-content-between"
                href="javascript:void(0)"
                onClick={() => {
                    setActive(!active)
                }}
            >
                <span class="ns-facet-name ns-font-4">
                    {facet.name}
                </span>
                <span class="plusminus" />
            </a>
            <div class={`ns-sidebar-submenu`}>
                <ul class={`ns-list-unstyled ns-p-0 ns-m-0 ns-facet-list-container ns-gap-4 ns-mt-4 ns-d-flex ${facet.data.length > 10 ? "ns-flex-row ns-flex-wrap" : "ns-flex-column"}`}>
                    {facet.data?.slice(0, facetThreshold).map((value, index) => {
                        return <Filter
                            facet={facet}
                            value={value}
                            index={index}
                        />
                    }
                    )}
                    <li class="ns-d-flex ns-align-items-center ns-font-3 ns-facet-container">
                        {facetThreshold < facet.data?.length && <span class="ns-facet-item" onClick={handleClickMore} style="text-transform: capitalize;">More {createPlural(facet.name)} +</span>}
                    </li>
                </ul>
            </div>
        </li>
    )
}
